import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate, Navigate } from "react-router-dom";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { PageHead } from "../components/PageTitle";
import {
  LoadingSpinner,
  TextInputForm,
} from "../components/Forms";
import { FaMagnifyingGlass } from "react-icons/fa6";


import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_DOMAIN from "../config/config";

const ProductTablehead = ["S.no", "Category", "Action"];

const CategoryList = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [show, setShow] = useState(false);


  const [crtCategory, setCategory] = useState(null);
  const [formData, setFormData] = useState({ category_name: "" });
  const [userData, setUserData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(true);

  const handleClose = () => {
    setShow(false);
    setCategory(null);
    navigate(location.pathname, { replace: true });
  };

  const handleShow = () => {
    setFormData({ category_name: "" });
    setCategory(null);
    setShow(true);
  };



  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    if (crtCategory) {
      setCategory({ ...crtCategory, [fieldName]: value });
    } else {
      setFormData({ ...formData, [fieldName]: value });
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const filteredUserData = userData.filter((item) =>
    (item?.category_name || "").toLowerCase().includes(searchText.toLowerCase())
  );

  const fetchData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/category.php?id=${companyId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: searchText }),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch data");

      const responseData = await response.json();

      setLoading(false);
    
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchText]);

  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      theme: "colored",
    });
  };

  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      theme: "colored",
    });
  };

  const handleSubmit = async () => {
    if (!formData.category_name?.trim()) {
      errorAlert("Category Name is required");
      return;
    }

    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/category.php?id=${companyId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const responseData = await response.json();

      if (responseData.status === 200) {
         successAlert(responseData.msg);
        setTimeout(() => {
          fetchData();
          handleClose();
          window.location.reload();
        }, 2000);
      } else {
        errorAlert(responseData.msg || "Missing required fields!");
      }
    } catch (error) {
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/category.php?id=${companyId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            category_id: crtCategory.category_id,
            category_name: crtCategory.category_name,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.status === 200) {
         successAlert(responseData.msg);
        setTimeout(() => {
            fetchData();
            handleClose();
            window.location.reload();
          }, 2000);
      } else {
        errorAlert(responseData.msg || "Update failed");
      }
    } catch (error) {
    }

    setLoading(false);
  };

  useEffect(() => {
    const session = localStorage.getItem("session");
    if (!session) {
      setIsLoggedIn(false);
    }
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <LoadingSpinner message="Loading CategoryItems..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid>
        <Row>
          <Col lg="12" className="py-3">
            <div className="main my-3">
              <Row className="mx-2">
                <Col lg="3">
                  <div className=" mx-2">
                    {/* <Buttons lable={<>Filter</>} onClick={showFilter} /> */}
                    <TextInputForm
                      placeholder={"Name"}
                      onChange={(e) => handleSearch(e.target.value)}
                      prefix_icon={<FaMagnifyingGlass />}
                      labelname={"Search"}
                    >
                      {" "}
                    </TextInputForm>
                  </div>
                </Col>
                <Col
                  lg="9"
                  className="d-flex align-item-baseline justify-content-end"
                >
                  <div className="text-end">
                    <Buttons lable={<> Add New</>} onClick={handleShow} />
                  </div>
                </Col>
              </Row>
              <div className="py-2 ">
                <TableUI
                  headers={ProductTablehead}
                  body={filteredUserData}
                  pageview={"yes"}
                  type="itemscategory"
                  onDelete={fetchData}
                  handleEditClick={(data) => {
                    setCategory(data);
                    setShow(true);
                  }}
                />
              </div>
            </div>
          </Col>

          
        </Row>
      </Container>

      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <PageHead pagehead={<>Add Category</>} onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <TextInputForm
            labelname={"Category Name"}
            placeholder={"Category Name"}
            name="category_name"
            value={
              crtCategory ? crtCategory.category_name : formData.category_name
            }
            onChange={(e) => handleChange(e, "category_name")}
          />
          <div className="text-center py-4">
            <ToastContainer />
            {crtCategory ? (
              <>
                <ClickButton
                  label={<>Update</>}
                  onClick={handleUpdateSubmit}
                    disabled={loading}
                  style={{ marginRight: "10px" }}
                />
                <ClickButton label={<>Cancel</>} onClick={handleClose} />
              </>
            ) : (
              <>
                <ClickButton
                  label={<>Submit</>}
                  onClick={handleSubmit}
                  style={{ marginRight: "10px" }}
                    disabled={loading}
                />
                <ClickButton label={<>Cancel</>} onClick={handleClose} />
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CategoryList;

